// Phase 1 — plays immediately on claim: a HERO scale-pop that holds at ~3x while the modal
// closes. Deliberately large (round 6: bumped from a subtle 1.15x micro-pop) — the pack is meant to
// read as the star of the screen for a beat, not just acknowledge the tap. Settles at
// PACK_FLY_POP_SCALE and stays there (no overshoot-then-shrink-back) until the fly leg launches and
// takes over the scale animation from wherever it currently is. A small optional drift toward
// screen center reinforces the "hero" staging.
export const PACK_FLY_SCALE_POP_S = 0.28;
export const PACK_FLY_POP_SCALE = 3;
export const PACK_FLY_HERO_DRIFT_PX = 24;

// Phase 2 — the fly leg: only launched once the claim dialog is confirmed gone (via
// RipsPackClaimFlyHost watching uiStore.openDialog), so the takeoff reads against the lobby, not
// the modal. Lands BY SHRINKING INTO the widget — position+scale run for the full duration so the
// player can track it all the way in; opacity is held near-1 and only fades in the final stretch
// (see PACK_FLY_FADE_MS) so the fade can never finish ahead of the movement.
export const PACK_FLY_TRAVEL_S = 0.62;
export const PACK_FLY_END_SCALE = 0.2;
export const PACK_FLY_FADE_MS = 100;

export const PACK_FLY_FALLBACK_TARGET_MARGIN_PX = 48;

// Safety cap only: if the "dialog closed" signal never arrives (store bug, dropped update, etc.),
// launch the fly leg anyway after this long so the clone can never hold forever. ~1.5s per QA.
export const PACK_FLY_HOLD_CAP_MS = 1500;

// Safety net only (mirrors PACK_FLY_HOLD_CAP_MS above, for the fly phase instead of the hold phase):
// onAnimationComplete already resolves as soon as the fly leg finishes — this guarantees the flight
// can never hang even if the animation fails to fire that callback (e.g. the tab is backgrounded and
// rAF is throttled). Exported (not local to useRipsPackClaimFly) so PACK_FLY_ADVANCE_CAP_MS below can
// derive from it.
export const FLY_SAFETY_TIMEOUT_MS = PACK_FLY_TRAVEL_S * 1000 + 500;

// Hard cap (round 6) on how long the claim dialog's popup-advance sequence (showNextPopup / the
// next queued bingo/daily-bonus/etc. dialog) will wait for this flight before proceeding anyway —
// see EventTriggerStore.awaitRipsPackClaimFlyDone. A missed advance wedges every future popup, so
// this must fire unconditionally regardless of why the flight didn't finish in time. Derived (not
// independently declared): the popup queue must outwait the flight's own worst case.
export const PACK_FLY_ADVANCE_CAP_MS = PACK_FLY_HOLD_CAP_MS + FLY_SAFETY_TIMEOUT_MS + 200;
